import { Page } from "@shopify/polaris";
import React, { useMemo } from "react";
import styled from "styled-components";
import { ProductsRMPolaris } from "../../components/recreate-mockup/ProductsRMPolaris";
import { getPathFromRouter } from "../../helper";

const Container = styled.div`
    margin: -1rem;
    @media (min-width: 640px) {
        margin: -1.5rem;
    }
`;

export const ProductsRMPagePolaris = (...props) => {
    const path = useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);
    return (
        <Container>
            <Page title="Recreate Mockup Tasks" fullWidth>
                <ProductsRMPolaris path={path} />
            </Page>
        </Container>
    );
};
